// extracted by mini-css-extract-plugin
module.exports = {"textbox":"TextBox-module--textbox--Wb1_j","title":"TextBox-module--title--2j7vk","text":"TextBox-module--text--4iotA","subtitle":"TextBox-module--subtitle--rJE85"};